import { useState } from "react";
import { MorphingSearchChips } from "./motion/morphing-search-chips";

/** Preserves the existing comma-separated form contract and caller-owned unfinished text. */
export function TagPicker({ value, onChange, suggestions, placeholder, id, suggestionLimit, suggestionLabels, draftValue, onDraftChange }: {
  value: string; onChange: (value: string) => void; suggestions: string[]; placeholder?: string; id?: string;
  suggestionLimit?: number; suggestionLabels?: { heading: string; more: string; less: string; add: string };
  draftValue?: string; onDraftChange?: (value: string) => void;
}) {
  const [localDraft, setLocalDraft] = useState("");
  const chips = value.split(",").map(tag => tag.trim()).filter(Boolean);
  return <MorphingSearchChips id={id} label={id ? undefined : "Tags or skills"} addLabel={suggestionLabels?.add}
    chips={chips} onChipsChange={tags => onChange(tags.join(", "))}
    query={draftValue ?? localDraft} onQueryChange={onDraftChange ?? setLocalDraft}
    suggestions={suggestions} maxSuggestions={suggestionLimit ?? 6} recents={[]} side="auto"
    placeholder={chips.length ? "" : placeholder || "Add a tag…"} normalize={term => term.trim().replace(/\s+/g, " ") || null}
    className="kph-tag-input max-w-none" />;
}
